import { CheckCircle } from "phosphor-react";

export default function GreenCheckIcon() {
  return (
    <div>
      <CheckCircle color={"#24B500"} size={30} />
    </div>
  );
}
